import { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, Mail } from 'lucide-react';
import { confirmEmailChange } from '../api';

export default function ConfirmEmailChangePage() {
  const [status, setStatus]     = useState<'pending' | 'success' | 'error'>('pending');
  const [message, setMessage]   = useState('');
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Mangler token i URL — link er ugyldigt.');
      return;
    }
    confirmEmailChange(token)
      .then(r => {
        setStatus('success');
        setNewEmail(r.new_email);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err instanceof Error ? err.message : 'Bekræftelse fejlede');
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-sm border p-8 text-center">
        {status === 'pending' && (
          <>
            <div className="mx-auto w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center mb-4">
              <Mail className="w-6 h-6 text-sage-700" />
            </div>
            <h1 className="text-xl font-bold text-ink-900 mb-2">Bekræfter email-skift…</h1>
            <p className="text-sm text-ink-500">Et øjeblik.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="mx-auto w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle2 className="w-6 h-6 text-sage-700" />
            </div>
            <h1 className="text-xl font-bold text-ink-900 mb-2">Email opdateret</h1>
            <p className="text-sm text-ink-500 mb-1">Din konto bruger nu</p>
            <p className="font-mono text-sm text-ink-900 mb-6">{newEmail}</p>
            <a href="/" className="btn btn-primary inline-block">Til forsiden</a>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="mx-auto w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center mb-4">
              <XCircle className="w-6 h-6 text-rose-700" />
            </div>
            <h1 className="text-xl font-bold text-ink-900 mb-2">Kunne ikke bekræfte</h1>
            <p className="text-sm text-ink-500 mb-6">{message}</p>
            <a href="/settings" className="btn btn-secondary inline-block">Til indstillinger</a>
          </>
        )}
      </div>
    </div>
  );
}
